import { CKSkeleton } from 'clearkit';

import { PageLayout } from '~/components/PageLayout';
import PlansAndBilling from '~/components/PlansAndBilling';
import { useCurrentUser } from '~/components/profile/useCurrentUser';

import { LoadingUpgradeSkeleton } from './PageTeamGrowthUpgrade';

export const PageTeamPlansAndBilling = () => {
  const account = useCurrentUser().account;

  const isLoading = !account;

  return (
    <PageLayout>
      <PageLayout.Header>
        <PageLayout.Heading>Plans & Billing</PageLayout.Heading>
        <PageLayout.SubHeading>
          <CKSkeleton className="h-[22.5px] w-[40ch]" isLoading={isLoading}>
            <span>
              Your team — <strong>{account?.name}</strong> — is currently on the
              Free plan.
            </span>
          </CKSkeleton>
        </PageLayout.SubHeading>
      </PageLayout.Header>
      <PageLayout.Body className="bg-white">
        <PageLayout.Content>
          {isLoading ? <LoadingUpgradeSkeleton /> : <PlansAndBilling />}
        </PageLayout.Content>
      </PageLayout.Body>
    </PageLayout>
  );
};
